import { Item } from '@lib/kontent'
import { PrivilegeItem } from '@lib/kontent/models/PrivilegeItem'

export function getSortedPrivilegeItems(
  privileges: Item<PrivilegeItem>[],
): Record<string, Item<PrivilegeItem>[]> {
  if (privileges.length === 0) {
    return {}
  }

  // Sort the privileges based on their category to group them together
  // this makes it easier to render them in the UI
  const sortedPrivilegeItems = privileges.reduce(
    (acc, privilege) => {
      const type = privilege.elements.category.value[0]

      if (!acc[type.codename]) {
        acc[type.codename] = []
      }
      acc[type.codename].push(privilege)
      return acc
    },
    {} as Record<string, Item<PrivilegeItem>[]>,
  )

  return sortedPrivilegeItems
}
